import styled from "styled-components/macro";

export const LoginPageStyles = styled.div`
  background:
    linear-gradient(
      0deg,
      color(display-p3 0.1216 0.1216 0.1216 / 0.04) 0%,
      color(display-p3 0.1216 0.1216 0.1216 / 0.04) 100%
    ),
    color(display-p3 1 1 1);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .login-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 56px;
  }

  .login-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    justify-content: center;
  }

  .login-logo {
    width: 164px;
    height: 62px;
    object-fit: cover;
  }

  .login-title {
    color: var(--Neutral-100);
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.056px;
  }

  .login-subtitle {
    color: var(--Neutral-60);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.014px;
  }

  .google-login-btn {
    border-radius: 40px;
    background: var(--Neutral-100);
    cursor: pointer;
    padding: 16px 24px;
    width: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: var(--White-100);
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.024px;
    height: 56px;
  }

  .login-action {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .warning-message {
      display: flex;
      align-items: center;
      gap: 8px;
      justify-content: center;

      svg {
        width: 16px;
        height: 16px;
      }

      .warning-text {
        color: var(--Error-100);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.014px;
      }
    }
  }

  .login-footer {
    padding: 16px;
    color: var(--Neutral-60);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.014px;

    .contact-us {
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
      text-underline-offset: 2px;
    }
  }
`;
